export function getOptionByValue({ items, selectedValue, }) {
    if (!items)
        return undefined;
    const option = items
        .map((el, index) => (Object.assign(Object.assign({}, el), { index })))
        .find((el) => {
        return (el === null || el === void 0 ? void 0 : el.value) === selectedValue;
    });
    if (option) {
        return option;
    }
    return undefined;
}
export function getInitialSelectedValueIndex({ defaultValue, values, name, items }, ifMultipleSelect) {
    const selectedValue = (values === null || values === void 0 ? void 0 : values[name]) || defaultValue;
    if (ifMultipleSelect) {
        // multi select
        if (selectedValue && typeof selectedValue === 'object') {
            const options = [];
            selectedValue.forEach((e) => {
                const option = getOptionByValue({
                    items,
                    selectedValue: e,
                });
                if (option) {
                    options.push(option.index);
                }
            });
            return options;
        }
        return [];
    }
    // single select
    const option = getOptionByValue({
        items,
        selectedValue,
    });
    if (option) {
        return option.index;
    }
    return -1;
}
export function buildSelectionValidator(selectedOptionsIndexes, selectedOptionIndex) {
    return (index) => selectedOptionsIndexes.indexOf(index) >= 0 || selectedOptionIndex === index;
}
